export default __webpack_public_path__ + "static/media/logo-us-bluemercury.a0a72d0f.svg";